import { render, staticRenderFns } from "./subInfos.vue?vue&type=template&id=1d4e6cb8&"
import script from "./subInfos.vue?vue&type=script&lang=js&"
export * from "./subInfos.vue?vue&type=script&lang=js&"
import style0 from "./subInfos.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports